import type { ApiCallerT } from "../../../../../shared/infrastructure/api/types";

import { balancesMapper } from "./mappers/balances.mapper";
import { createBalancesApi } from "./api/balances.api";
import { createBalancesRepository } from "./repositories/balances.repository";

import { accrualsMapper } from "./mappers/accruals.mapper";
import { createAccrualsApi } from "./api/accruals.api";
import { createAccrualsRepository } from "./repositories/accruals.repository";

import { collaboratorAccrualsMapper } from "./mappers/collaboratorAccruals.mapper";
import { createCollaboratorAccrualsApi } from "./api/collaboratorAccruals.api";
import { createCollaboratorAccrualsRepository } from "./repositories/collaboratorAccruals.repository";

export const buildBalancesRepository = ({
  apiCaller,
}: {
  apiCaller: ApiCallerT;
}) => {
  const balancesApi = createBalancesApi(apiCaller);

  return createBalancesRepository({ balancesApi, balancesMapper });
};

export const buildAccrualsRepository = ({
  apiCaller,
}: {
  apiCaller: ApiCallerT;
}) => {
  const accrualsApi = createAccrualsApi(apiCaller);

  return createAccrualsRepository({ accrualsApi, accrualsMapper });
};

export const buildCollaboratorAccrualsRepository = ({
  apiCaller,
}: {
  apiCaller: ApiCallerT;
}) => {
  const collaboratorAccrualsApi = createCollaboratorAccrualsApi(apiCaller);

  return createCollaboratorAccrualsRepository({
    collaboratorAccrualsApi,
    collaboratorAccrualsMapper,
  });
};
